"use client";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

const BreadcrumbsSnippet = ({siteUrl}) => {
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const pathname = usePathname();

    useEffect(() => {
      if (pathname) {
        const pathArray = pathname.split('/').filter((path) => path);
        const breadcrumbList = pathArray.map((path, index) => {
          const url = '/' + pathArray.slice(0, index + 1).join('/');
          return {
            '@type': 'ListItem',
            position: index + 1,
            name: capitalize(path),
            item: `${siteUrl}${url}`,
          };
        });
  
        // Add home as the first breadcrumb
        const homeBreadcrumb = {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: siteUrl,
        };
  
        setBreadcrumbs([homeBreadcrumb, ...breadcrumbList]);
      }
    }, [pathname]);
  
    const capitalize = (str) => {
      return str.charAt(0).toUpperCase() + str.slice(1);
    };
  
    return (
      <>
        {breadcrumbs.length > 0 && (
          <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: breadcrumbs,
            })}
          </script>
        )}
      </>
    );
  };

export default BreadcrumbsSnippet;
